import employeeService from '@/services/employees'
import Vue from 'vue'
import smartlookClient from 'smartlook-client'
import * as Sentry from '@sentry/browser'
import { app } from '@/main'

export default {
  namespaced: true,
  state: {
    user: null,
    token: null
  },
  getters: {
    isAuthenticated (state) {
      return state.user !== null && state.token !== null
    },
    token (state) {
      return state.token
    },
    user (state) {
      return state.user
    }
  },
  actions: {
    LOGIN ({ commit, dispatch }, credentials) {
      return employeeService.login(credentials)
        .then(data => dispatch('PERSIST_TOKEN', data))
        .then(data => dispatch('SET_USER', data.data.user))
        .then(() => dispatch('RECEIPT/RESET_RECEIPT', null, { root: true }))
        .catch((data) => Promise.reject(data.data))
    },

    LOGOUT ({ dispatch }, token) {
      return employeeService.logout(token)
        .then(() => {
          return dispatch('RESET_USER').then(() => {
            return app.$router.replace({ 'name': 'Login' }).catch(err => { console.log(err) })
          })
        })
    },

    RESET_USER ({ commit }) {
      commit('RESET_USER')
      commit('SET_TOKEN', null)
      commit('SET_SHOW_FULL_CATALOG', null, { root: true })
    },

    SET_USER ({ commit }, user) {
      commit('SET_USER', user)
    },

    PERSIST_TOKEN ({ commit }, data) {
      if (typeof data.auth === 'undefined' || typeof data.auth.token === 'undefined') {
        const error = {
          message: 'Authentication failed.',
          originalData: data
        }
        return Promise.reject(error)
      }

      commit('SET_TOKEN', data.auth.token)

      return Promise.resolve(data)
    },

    FETCH_USER ({ commit }, token) {
      return employeeService.findByToken(token)
        .then((data) => {
          // Set rollbar person information
          Vue.rollbar.configure({
            payload: {
              person: {
                id: _.get(data, 'data.user.id'),
                username: `${_.get(data, 'data.user.first_name')} ${_.get(data, 'data.user.last_name')}`,
                email: _.get(data, 'data.user.email')
              }
            }
          })

          Sentry.configureScope(scope => {
            scope.setUser({
              id: _.get(data, 'data.user.id'),
              username: `${_.get(data, 'data.user.first_name')} ${_.get(data, 'data.user.last_name')}`,
              email: _.get(data, 'data.user.email')
            })
          })

          // Set smartlook person information
          smartlookClient.identify(data.data.user.id, {
            name: `${data.data.user.first_name} ${data.data.user.last_name}`,
            email: data.data.user.email
          })

          return commit('SET_USER', data.data.user)
        })
        .catch((data) => Promise.reject(data.data))
    }
  },
  mutations: {
    RESET_USER (state) {
      state.user = null
    },

    SET_USER (state, user) {
      state.user = user
    },

    SET_TOKEN (state, token) {
      state.token = token
    },

    DELETE_TOKEN (state) {
      state.token = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/authentication.js